import React from 'react';
import styles from './ProfilCard.module.css';

const ProfilHeader = ({ firstname, role, category, setCategory }) => {
    const handleCategoryChange = (e) => {
        setCategory(e.target.value);
    };

    return (
        <div className={styles.profilHeader}>
            <h1 className={styles.title}>Bonjour {firstname} 👋🏻</h1>
            {role === 'Commerçant' && (
                <div className={styles.categoriesBox}>
                    <label className={styles.labelCategories} htmlFor="categories">Choisissez votre secteur :</label>
                    <select
                        className={styles.categories}
                        id="categories"
                        name="categories"
                        value={category}
                        onChange={handleCategoryChange}
                    >
                        <option value="restaurants">Restaurants</option>
                        <option value="activity">Activités</option>
                        <option value="beauty">Bien-être & Spa</option>
                        <option value="cars">Services auto</option>
                        <option value="alimentation">Épiceries</option>
                    </select>
                </div>
            )}
            <p className={styles.subtitle}>{role}</p>
        </div>
    );
};

export default ProfilHeader;
